<div class="main-app container-fluid full-size p-2">
  <div class="row m-0">
    <div class="col-md-4 pr-2">
      <img [src]="picture" class="picture">
    </div>
    <div class="col-md-8">
      <h3 class="text-{{theme.brightContrast}}">{{ userName }}</h3>
    
      <ng-container *ngIf="isLogged">
        <div class="pl-2">
          <p class="text-{{theme.brightContrast}}">{{ email }}</p>
        </div>
      </ng-container>
    
      <button *ngIf="!isLogged" [disabled]="locked" (click)="login()" class="btn btn-success">Sign in / sign up</button>
    </div>
  </div>
</div>